import { useLocalSearchParams } from "expo-router";
import { DocumentForm } from "~/components/form/health-profile/DocumentForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useGallery } from "~/providers/GalleryProvider";

export default function EditPainPlan() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findDocument } = useGallery();
    const { handleDismiss } = useDismiss();
    const document = findDocument(id, true);

    if (!document) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="documents">
            <DocumentForm document={document} onRequestClose={handleDismiss} asRoute painPlan />
        </Authorize>
    );
}
